import { createAction, props } from '@ngrx/store';
import { RestApiError } from 'src/app/common-components/errors/models/error-message';
import { UserPasswordResetRequestModel } from '../models/user-password-reset-request.model';

export const userPasswordResetRequest = createAction('[User Password Reset Request] Start Request');

export const submitUserPasswordResetRequest = createAction(
   '[User Password Reset Request] Submit Request',
   props<{ userPasswordResetRequest: UserPasswordResetRequestModel }>()
);

export const submitUserPasswordResetRequestSuccess = createAction(
   '[API] Submit Success',
   props<{ userPasswordResetRequest: UserPasswordResetRequestModel }>()
);
export const userPasswordResetRequestClose = createAction('[User Password Reset Request] Close');

export const submitUserPasswordResetRequestFailure = createAction('[API] Submit Failure', props<RestApiError>());
